export class DateUtils {
  static convertTimestampToDateTime(timestamp: number | null): string | null {
    if (timestamp === null || isNaN(timestamp)) {
      return null;
    }

    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      return null;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  static convertToTimestamp(dateStr: string): number | null {
    // Controllo formato con regex
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(dateStr)) {
      return null;
    }

    const [day, month, year] = dateStr.split('/').map(Number);

    // Creiamo la data
    const date = new Date(year, month - 1, day);

    // Verifica che la data sia realmente quella richiesta
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null; // data non valida (es. 31/02/2026)
    }

    return date.getTime();
  }
}
